package one.healthium.domain.user.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class PersonalPlanPeriod {
    @SerialName("21days")
    In21days,

    @SerialName("3month")
    In3month,

    @SerialName("3month_short")
    In3monthShort,
}